import { useState } from "react";
import { logsLink, nrqlLink, orderSpansNrql, type NrConfig } from "./newrelic";

// Ported from load-generator-ui's NrLinks.tsx (#118) — the per-order half
// only (RunNrLinks has no equivalent here, this screen has no "run").

/** Copy `text` to the clipboard; flips the label to "copied" for a beat. */
export function CopyButton({ text, label = "copy NRQL" }: { text: string; label?: string }) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      className="nr-copy"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          setDone(true);
          window.setTimeout(() => setDone(false), 1200);
        } catch {
          setDone(false);
        }
      }}
    >
      {done ? "copied ✓" : label}
    </button>
  );
}

/** Per-order New Relic links: Logs (base URL only), the NRQL query builder,
 *  and a copy button for the "one order, all spans" query. */
export function OrderNrLinks({ orderId, cfg }: { orderId: string; cfg: NrConfig }) {
  const spans = orderSpansNrql(orderId);
  const logs = logsLink(cfg, orderId);
  const nrql = nrqlLink(cfg, spans);

  return (
    <span className="nr-links">
      {logs && (
        <a href={logs} target="_blank" rel="noreferrer">
          Logs
        </a>
      )}
      {nrql && (
        <a href={nrql} target="_blank" rel="noreferrer">
          spans
        </a>
      )}
      <CopyButton text={spans} label="copy" />
    </span>
  );
}
